import * as Mui from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import useOperationTranslation from "../../../../hooks/useOperationTranslation";
import { customTheme } from "../../../../../../config/theme/MuiTheme";

interface Props {
    open: boolean;
    onClose: () => void;
    taskName : string;
    onCloseTask: () => void;
};
const ToBeChargedConfirmation = (props: Props) => {
    const t = useOperationTranslation();

    return(
        <Mui.Dialog
            open={props.open}
            fullWidth
            maxWidth="sm"
            onClose={props.onClose}
        >
            <Mui.DialogTitle>
                <Mui.Grid container spacing={1}>
                    <Mui.Grid item color={customTheme.palette.accent.main}>
                        <InfoIcon color="inherit" />
                    </Mui.Grid>
                    <Mui.Grid item>
                        <Mui.Typography variant="h5">
                            {t("damageForm.details.dialogs.tbcConfirmation.title")}
                        </Mui.Typography>
                    </Mui.Grid>
                    <Mui.Grid item marginLeft={"auto"}>
                        <Mui.IconButton onClick={props.onClose} style={{padding: "0px"}} >
                            <CloseIcon />
                        </Mui.IconButton>
                    </Mui.Grid>
                </Mui.Grid>
            </Mui.DialogTitle>
            <Mui.DialogContent>
                <Mui.Typography>
                    {t("damageForm.details.dialogs.tbcConfirmation.body1")}
                </Mui.Typography>
                <Mui.Typography pt="10px">
                {t("damageForm.details.dialogs.tbcConfirmation.body2")}
                </Mui.Typography>
            </Mui.DialogContent>
            
            <Mui.DialogActions>
                <Mui.Button variant="outlined" onClick={props.onClose} size="smallPlus">
                    <Mui.Typography variant="h6" color="inherit">
                        {t("damageForm.details.dialogs.tbcConfirmation.btnCancel")}
                    </Mui.Typography>
                </Mui.Button>

                <Mui.Button type="submit" onClick={props.onCloseTask} size="smallPlus">
                    <Mui.Typography variant="h6" color="inherit">
                        {t("damageForm.details.dialogs.tbcConfirmation.btnTBC")}
                    </Mui.Typography>
                </Mui.Button>
            </Mui.DialogActions>
        </Mui.Dialog>
    )
}
export default ToBeChargedConfirmation;